import React, { lazy } from 'react';
import { LoadComponent, type RouteObject } from 'Routes/index';

//const Perfil = lazy(() => import('Pages/Profile/Profile/User'));
//const Escritorios = lazy(() => import('Pages/Profile/escritorios/List'));

const ProfileRoutes: RouteObject[] = [];

export default ProfileRoutes;
